import React from 'react';
import { useTranslation } from 'react-i18next';
import CustomTreeView from '../../../../../components/Tree/CustomTreeView';
import CustomModal from '../../../../../components/Modal/CustomModal';
import { CustomCheckbox } from '../../../../../components/CustomCheckbox';
import CustomDaySelector from '../../../../../components/CustomDaySelector';
import CustomTimePicker from '../../../../../components/CustomTimePicker';
import { ButtonNextStep } from '../../../../../components/buttons/ButtonNavigation';
import { AddIcon } from '../../../../../components/buttons/IconButtons';
import CustomTable from '../../../../../components/table/CustomTable';
import CustomizedTable from '../Table/CustomizedTable';
import Customized from '../Functionality/Customized';
import NotInformation from '../../../../../components/NotInformation';
import DividerWithText from "../../../../../components/DividerWithText";

const AddCustomizedSchedule = ({ open, onClose, customizedList, setCustomizedList }) => {
    const { t } = useTranslation();

    const {
        zoneData,
        setChecked,
        setDayArray,
        handleCheck,
        selectAllDays,
        handleAllTime,
        handleCLick,
        handleRemoveAccess,
        handleConfirm,
        handleClose,
        item,
        setItem,
        emptyFields,
        isValidTo
    } = Customized({
        customizedList,
        setCustomizedList,
        show: open
        });

    const { tableId, searchId, thead, tbody, getActionsButtons } = CustomizedTable({
        data: customizedList,
        handleRemoveAccess: handleRemoveAccess
    });

    return (
        <CustomModal
            title={'add'}
            size='lg'
            buttonConfirm='confirm'
            show={open}
            onHide={() => {
                handleClose();
                onClose();
            }}
            onConfirm={() => {
                handleConfirm();
                onClose();
            }}
            disabled={customizedList.filter(e => !e?.added).length === 0}
        >
            <div className='row'>
                <div className='col-lg-6 work_shift_tree_view'>
                    <CustomTreeView
                        tittle={'zones'}
                        key={'WorkShiftTreeView'}
                        data={zoneData}
                        onInputchange={handleCheck}
                        isChecked={item.checkedZones}
                        checked={item.checkedZones}
                        setChecked={setChecked}
                    />
                </div>
                <div className='col-lg-6'>
                    <div className='d-flex justify-content-between'>
                        <div>
                            <span className='schedule-heading'>{t('schedule')}</span>
                            <span className='schedule-heading-sub-heading'>{t('to_open_the_doors')}</span>
                        </div>

                        <CustomCheckbox
                            id={"cb_acs_de_select_all_days"}
                            trans='all_days'
                            checked={item.dayArray?.length > 0 && item.dayArray?.length === 7}
                            onChange={selectAllDays}
                        />
                    </div>
                    <CustomDaySelector
                        required
                        emptyFields={emptyFields}
                        dayArray={item.dayArray}
                        setDayArray={setDayArray}
                        containerClasses={'no-width'}
                    />
                    <div className='col-12 p-0'>
                        <div className='mt-2 access_text'>
                            <CustomCheckbox id={"cb_acs_de_select_all_days"}
                                            trans={t("all_time")}
                                            name={"allTime"}
                                            checked={item.allTime}
                                            onChange={(e) => handleAllTime(e)}
                                            marginbutton={true}
                            />
                        </div>
                        <div className='mt-3'>
                            <CustomTimePicker
                                title={t('from')}
                                name="fromTime"
                                value={item.fromValue}
                                handleChange={(newValue) => {
                                    setItem((prev) => ({ ...prev, fromValue: newValue }));
                                }}
                                disabled={item.allTime}
                                ampm={false}
                                inputFormat="HH:mm:ss"
                                required
                                id={'txt_acs_from_time'}
                                actions={['accept', 'cancel']}
                                emptyFields={emptyFields}
                                formatValue={false}
                                maxDate={item.toValue ? new Date(item.toValue) : undefined}
                            />
                        </div>
                        <div className='mt-3'>
                            <CustomTimePicker
                                id={'txt_acs_to_time'}
                                title={t('to')}
                                name="toTime"
                                value={item.toValue}
                                handleChange={(newValue) => {
                                    setItem((prev) => ({ ...prev, toValue: newValue }));
                                }}
                                disabled={item.allTime}
                                ampm={false}
                                inputFormat="HH:mm:ss"
                                required
                                actions={['accept', 'cancel']}
                                emptyFields={emptyFields}
                                formatValue={false}
                                isValid={isValidTo}
                                isValidText={'this_cant_have_at_least_time_to_from_or_same_time'}
                                helperText={t('this_cant_have_at_least_time_to_from_or_same_time')}
                            />
                        </div>
                        <div className='mt-2'>
                            <ButtonNextStep
                                id='btn_ce_next_card'
                                text='add'
                                Icon={AddIcon}
                                click={(e) => {
                                    handleCLick(e);
                                }}
                            />
                        </div>
                    </div>
                </div>

                <div className={"col-12 mt-3 mb-3 "}>
                    <DividerWithText/>
                </div>

                {(customizedList.length !== 0 && customizedList.some((item) => item.added === false)) ?
                    <div className='col-12'>
                        <CustomTable
                            tableId={tableId}
                            searchId={searchId}
                            thead={thead}
                            tbody={tbody}
                            getActionsButtons={getActionsButtons}
                            columnActions={true}
                            inModal={true}
                        />
                    </div>
                    : <div className={"col-12"}>
                        <span className='contractor-access-heading'>{t('access')}</span>
                        <NotInformation text={t('no_information')} card={false} />
                    </div>
                }
            </div>
        </CustomModal>
    );
};

export default AddCustomizedSchedule;
